var map = {
	"./areas/administration/template/serviceModelForm/translations": "./src/app/areas/administration/template/serviceModelForm/translations.ts",
	"./areas/assets/monitors/shared-components/translations": "./src/app/areas/assets/monitors/shared-components/translations.ts",
	"./areas/cost/translations": "./src/app/areas/cost/translations.ts",
	"./areas/dashboards/DashboardsGridStore/components/DuplicateDashboardWizard/translations": "./src/app/areas/dashboards/DashboardsGridStore/components/DuplicateDashboardWizard/translations.ts",
	"./areas/dashboards/DashboardsGridStore/translations": "./src/app/areas/dashboards/DashboardsGridStore/translations.ts",
	"./areas/data-sources/components/DataSourceDataConstructor/translations": "./src/app/areas/data-sources/components/DataSourceDataConstructor/translations.ts",
	"./areas/data-sources/translations": "./src/app/areas/data-sources/translations.ts",
	"./areas/incidents/IncidentsGridStore/translations": "./src/app/areas/incidents/IncidentsGridStore/translations.ts",
	"./areas/incidents/widgets/IncidentsGridWidget/translations": "./src/app/areas/incidents/widgets/IncidentsGridWidget/translations.ts",
	"./areas/master-list/translations": "./src/app/areas/master-list/translations.ts",
	"./areas/metrics/components/LabelOptionsEditor/translations": "./src/app/areas/metrics/components/LabelOptionsEditor/translations.ts",
	"./areas/metrics/components/MetricLegendSelect/translations": "./src/app/areas/metrics/components/MetricLegendSelect/translations.ts",
	"./areas/metrics/components/MetricSelector/translations": "./src/app/areas/metrics/components/MetricSelector/translations.ts",
	"./areas/metrics/components/MetricTooltipSelect/translations": "./src/app/areas/metrics/components/MetricTooltipSelect/translations.ts",
	"./areas/metrics/widgets/Compass/translations": "./src/app/areas/metrics/widgets/Compass/translations.ts",
	"./areas/monitors/components/MonitorEventsGrid/translations": "./src/app/areas/monitors/components/MonitorEventsGrid/translations.ts",
	"./areas/monitors/system-monitor/SystemMonitorPage/translations": "./src/app/areas/monitors/system-monitor/SystemMonitorPage/translations.ts",
	"./areas/service-boards/chartSettings/translations": "./src/app/areas/service-boards/chartSettings/translations.ts",
	"./controls/designer/features/widgets/datasources/shared/translations": "./src/app/controls/designer/features/widgets/datasources/shared/translations.tsx",
	"./controls/react/form/formBuilderNew/translations": "./src/app/controls/react/form/formBuilderNew/translations.ts",
	"./core/localization/translations": "./src/app/core/localization/translations.ts",
	"./framework/time/translations": "./src/app/framework/time/translations.ts",
	"./layout/userTags/translations": "./src/app/layout/userTags/translations.ts"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/app sync recursive translations$";